import useCrud from 'hooks/useCrud';
import { useCallback } from 'react';
import { profileRecord, ProfileRecordBody } from 'services/api/remind';

function useProfileRecord() {
  return useCrud({
    readList: useCallback(
      (body: ProfileRecordBody) => profileRecord(body).then((res) => res.remindReportRecord),
      [],
    ),
  });
}

export default useProfileRecord;
